import ComponentRepository from "@/repositories/tuevs/ComponentRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'component',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listOne({commit, state}, id) {
            commit('setLoading', true)
            await ComponentRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data.component)
            })
            commit('setLoading', false)
        },
        async listAll({commit, state}, params) {
            commit('setLoading', true)
            await ComponentRepository.fetchAll(params).then(response => {
                commit('setPagination', {
                    ...state.pagination,
                    total: response.data.total
                })
                commit('setAll', response.data.data)
            })
            commit('setLoading', false)
        },
        async search ({ commit, state }, params) {
            commit('setLoading', true)
            await ComponentRepository.fetchAll(params).then(response => {
                if (response.data.data.length > 0){
                    const array = response.data.data
                    commit('setAll', Object.values([...state.list, ...array].reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))
                }
            })
            commit('setLoading', false)
        }
    }
}
